import React, { useMemo } from 'react'
import { bool, any, func, object } from 'prop-types'
import { Button, Stack, styled, css, useTheme } from '@mui/material'
import RTGLink from '@shared/link'
import { checkIfOutOfStockByStockMessage } from '@helpers/product'

const AddToCartModalButtonsStyles = styled(Stack)(css`
  button {
    font-weight: 600;
  }

  a {
    display: block;
    button {
      width: 100%;
    }
  }
`)

const StyledButton = styled(Button)(({ theme }) => ({
  border: `1px solid ${theme.palette.primary.main}`,
}))

const AddToCartModalButtons = ({
  closeModal,
  includesRequiredAddon,
  reqAddedToCart,
  reqConfirmed,
  onAddRequiredAddon,
  requiredAddon,
  stockMessage,
}) => {
  const isOutOfStock = useMemo(() => checkIfOutOfStockByStockMessage(stockMessage), [stockMessage])
  const buttonText = `view cart 
    ${!isOutOfStock ? '& checkout' : ''}`
  const handleButtonClick = () => {
    onAddRequiredAddon(requiredAddon)
  }
  const theme = useTheme()
  return (
    <AddToCartModalButtonsStyles>
      {includesRequiredAddon && !reqAddedToCart && (
        <Button
          variant="outlined"
          type="button"
          disabled={!reqConfirmed}
          value="Add to cart"
          onClick={handleButtonClick}
        >
          Add to Cart
        </Button>
      )}

      {(!includesRequiredAddon || (includesRequiredAddon && reqConfirmed && reqAddedToCart)) && (
        <>
          {window && !window.location.pathname.includes('/cart') && (
            <RTGLink
              data={{
                slug: '/cart',
                title: 'Cart',
              }}
              className="checkout"
            >
              <StyledButton color="primary" data-testid="view-cart-button" variant="outlined" onClick={closeModal}>
                {buttonText}
              </StyledButton>
            </RTGLink>
          )}
          {window && window.location.pathname.includes('/cart') && (
            <Button variant="contained" onClick={closeModal}>
              {buttonText}
            </Button>
          )}
        </>
      )}
    </AddToCartModalButtonsStyles>
  )
}

AddToCartModalButtons.propTypes = {
  closeModal: func,
  includesRequiredAddon: bool,
  reqAddedToCart: bool,
  reqConfirmed: bool,
  onAddRequiredAddon: func,
  requiredAddon: object,
  stockMessage: any,
}

export default AddToCartModalButtons
